import * as $ from 'jquery';

const settings = {
	formfilter: '.js-form-filter',
	formfilterContainer: '.js-form-filter-container',
	inputAutoSubmit: '.js-auto-submit',
	filterSubmit: '.js-filter-submit',
	spinner: '.js-spinner'
};

var lastRequest;

const init = () => {
	hideFilterSubmit();
	$(settings.formfilterContainer).on('change', $(settings.inputAutoSubmit), handleFilterForm);
};

const handleFilterForm = () => {
	const $formfilter = $(settings.formfilter);
	const $spinner = $(settings.spinner);

	if (lastRequest) {
		lastRequest.abort();
	}
	lastRequest = $.ajax({
		url: $formfilter.attr('action'),
		type: $formfilter.attr('method'),
		data: $formfilter.serialize(),
		beforeSend: function() {
			$spinner.show();
		},
		success: function(result) {
			const content = $(result).find(settings.formfilterContainer).html();
			const $formfilterContainer = $(settings.formfilterContainer);

			$formfilterContainer.html(content);
			hideFilterSubmit();

			const event = document.createEvent('Event');
			event.initEvent('formRefreshed', false, true);
			window.dispatchEvent(event);
		}
	});

	return false;
};

// Hide the filter submit button if javascript is enabled
const hideFilterSubmit = () => {
	const filterSubmit = $(settings.filterSubmit);

	if (!!filterSubmit) filterSubmit.css('display', 'none');
};

init();
